<template>
  <app-dialog
    v-model="openModel"
    content-class="dialogBonusConditionInsurance"
    @onClose="$emit('onClose')"
  >
    <template v-slot:title>
      <h1 class="dialogBonusConditionInsurance-title">
        団体医療保険制度 試算にあたっての留意事項
      </h1>
    </template>
    <v-card>
      <v-card-text class="dialogBonusConditionInsurance-content">
        <p>
          こちらの保険料シミュレーションページは本人のみ試算可能です。
        </p>
        <p>
          試算保険料は、2024年7月1日～2025年1月1日の契約に適用される保険料です。
        </p>
        <p>
          ご加入できる方の範囲は、従業員ご本人、ご本人の配偶者・こども・両親・兄弟姉妹です(同居・扶養の制限はありません。)。
        </p>
        <p>
          退職後は新規加入や保障の追加・増額はできません。
        </p>
      </v-card-text>
    </v-card>
  </app-dialog>
</template>

<script>
export default {
  name: 'DialogBonusConditionInsurance',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.dialogBonusConditionInsurance {
  max-width: 720px;
  &-content {
    &.v-card__text {
      padding: 0 30px 20px 44px !important;
    }
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    margin-top: 15px;
    margin-bottom: 5px;
    width: 100%;
  }

  p {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.64;
    letter-spacing: normal;
    text-align: left;
    color: #333;
    display: inline-block;
    margin-bottom: 5px;
    &::before {
      content: '※';
      display: inline-block; /* Needed to add space between the bullet and the text */
      width: 10px; /* Also needed for space (tweak if needed) */
      margin-left: -15px; /* Also needed for space (tweak if needed) */
    }
  }
}
</style>
